import { render, staticRenderFns } from "./PasoAsociacion.vue?vue&type=template&id=d3584956&"
import script from "./PasoAsociacion.vue?vue&type=script&lang=ts&"
export * from "./PasoAsociacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports